import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import '../styles/Sector.css';
import logo from '../assets/Sectorpic.png';
import centerImage from '../assets/logo.png'; // Replace with your actual image
import slide1 from '../assets/mc-10.webp';
import slide2 from '../assets/cg2.jpg';
import slide3 from '../assets/parralex4.jpg';
import slide4 from '../assets/mc9.webp';
import slide5 from '../assets/mc-12.jpg';

const slideImages = [
  { src: slide1, alt: 'Slide 1' },
  { src: slide2, alt: 'Slide 2' },
  { src: slide3, alt: 'Slide 3' },
  { src: slide4, alt: 'Slide 4' },
  { src: slide5, alt: 'Slide 5' },
];

const Sector = () => {
  const numSeats = slideImages.length;
  const angleIncrement = 360 / numSeats;

  const textRef = useRef(null);
  const wheelRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-up-visible');
          observer.unobserve(entry.target); // Only once
        }
      });
    }, observerOptions);

    if (textRef.current) observer.observe(textRef.current);
    if (wheelRef.current) observer.observe(wheelRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-section" id="about">
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* ABOUT US */}
      </motion.h1>

      <motion.p
        className="intro-text"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        Apexcel is named after a combination of apex (highest part of something)
        and excel (proficient in an activity). We provide innovative engineering
        solutions, modern equipment rentals, and reliable manpower services to
        power industries forward.
      </motion.p>

      <motion.div
        className="center-image"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <img src={centerImage} alt="Team working" />
      </motion.div>

      <div className="sector-layout">
        <div ref={textRef} className="sector-text fade-up-init">
          <h3>Electrical Engineering</h3>
          <ul>
            <li>Powering Innovation and Infrastructure: Electrical engineering drives the development of essential technologies—from power generation and distribution to advanced electronics—supporting modern life, industry, and smart infrastructure.</li>
            <li>Bridging Theory and Application: It combines scientific principles with practical design to create efficient, safe, and sustainable solutions in energy, automation, communication, and control systems.</li>
          </ul>

          <h3>Mechanical Engineering</h3>
          <ul>
            <li>Energy Efficiency and Indoor Comfort: A well-designed HVAC system optimizes airflow, temperature, and humidity, enhancing occupant comfort while reducing energy consumption and operational costs.</li>
            <li>System Reliability and Lifecycle Performance: Proper mechanical design ensures long-term reliability, ease of maintenance, and compliance with building codes and environmental standards, extending the system’s lifespan.</li>
          </ul>

          <h3>Civil Engineering</h3>
          <ul>
            <li>Functional and Space-Efficient Layouts: Effective planning ensures optimal use of space, aligning structural elements, utilities, and architectural needs to enhance usability, comfort, and aesthetics.</li>
            <li>Compliance and Structural Integrity: Proper design guarantees that buildings meet safety codes, load requirements, and environmental standards, ensuring durability, safety, and regulatory approval.</li>
          </ul>
        </div>

        <div className="sector-sector-container fade-up-init" ref={wheelRef}>
          <div className="sector-logo-container">
            <img src={logo} alt="Center Logo" className="sector-center-logo" />
          </div>

          <div className="sector-ferris-wheel">
            {slideImages.map((image, index) => {
              const seatAngle = angleIncrement * index;
              const wrapperStyle = {
                transform: `rotate(${seatAngle}deg) translateY(var(--sector-wheel-radius)) rotate(-${seatAngle}deg)`,
              };

              return (
                <div
                  key={index}
                  className="sector-seat-wrapper"
                  style={wrapperStyle}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="sector-seat-image"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sector;
